import type { ReferenceTitleDto } from '@gr/core/content/entities/dto';
import type { ReferenceTarget } from '@gr/core/content/entities/fields';

/** Запись или пост, на которые может ссылаться поле (ENT-UC-8). */
export interface ReferenceCandidate {
  id: string;
  title: string;
}

export interface ReferencePage {
  items: ReferenceCandidate[];
  hasMore: boolean;
}

/** Поиск целей ссылки по заголовку, страницами; null — загрузить не удалось. */
export type SearchReferences = (target: ReferenceTarget | undefined, query: string, offset: number, signal: AbortSignal) => Promise<ReferencePage | null>;

/**
 * Всё, что нужно полям-ссылкам формы: поиск целей и заголовки уже выбранных (ENT-UC-8.CC-2).
 * Даёт подключённый компонент (useReferenceSearch), в витрине — фикстура.
 */
export interface ReferenceLookup {
  search: SearchReferences;
  titles: Readonly<Record<string, string>>;
}

/** Страница из запроса на size + 1 строк: лишняя строка значит, что есть ещё. */
export function pageOf<T>(rows: readonly T[], size: number): { items: T[]; hasMore: boolean } {
  return { items: rows.slice(0, size), hasMore: rows.length > size };
}

/** Заголовки целей по id — из referenceTitles записи или поста. */
export function titlesOf(referenceTitles: Readonly<Record<string, ReferenceTitleDto>> | null | undefined): Record<string, string> {
  return Object.fromEntries(Object.values(referenceTitles ?? {}).map((ref) => [ref.id, ref.title]));
}
